import { render, staticRenderFns } from "./editProviderGameOff.vue?vue&type=template&id=120d1511&lang=pug"
import script from "./editProviderGameOff.vue?vue&type=script&lang=js"
export * from "./editProviderGameOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports